import { useQuery } from '@tanstack/react-query';
import { getFilesList } from 'config/requests';

export const UPLOAD_FILES = 'upload_files';

export function useGetFiles(entity: string, id?: number) {
  const { data, isLoading } = useQuery({
    queryKey: [UPLOAD_FILES, id],
    queryFn: () => getFilesList(entity, id!),
    enabled: Boolean(id),
  });

  return { data, isLoading };
}
